import { render, staticRenderFns } from "./PreviewProject.vue?vue&type=template&id=f385128e&scoped=true&"
import script from "./PreviewProject.vue?vue&type=script&lang=js&"
export * from "./PreviewProject.vue?vue&type=script&lang=js&"
import style0 from "./PreviewProject.vue?vue&type=style&index=0&id=f385128e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f385128e",
  null
  
)

export default component.exports